import React from "react";
import { newContextComponents } from "@drizzle/react-components";
import { Accordion, Card, Button, ProgressBar, Table } from 'react-bootstrap';

import ChangeAdmin from './ChangeAdmin'
import AdminIssueRefund from './AdminIssueRefund'
import EmergencySuicide from './EmergencySuicide'
import ResetEscrow from './ResetEscrow'
import SetEscrowState from './SetEscrowState'
import PauseICO from './PauseICO'
import ContributionStatistics from './ContributionStatistics'
import GetChangeValue from './GetChangeValue'
import Finalize from './Finalize'
import MoveTokensFromContract from './MoveTokensFromContract'
import MoveBNBFromContract from './MoveBNBFromContract'
import SetTime from './SetTime'
import WhitelistStatistics from './WhitelistStatistics'
import WithdrawFunds from './WithdrawFunds'
import BalanceOfICO from './BalanceOfICO'

import { Web3StatusContext } from "../../contexts/Web3StatusContext";

const { AccountData, ContractData, ContractForm } = newContextComponents;

class ICO extends React.Component {
  static contextType = Web3StatusContext;
  
  componentDidMount() {
    
  }

  componentDidUpdate() {
    
  }

  // destructure drizzle and drizzleState from props
  render() {
    return (
        <div>
          <Table striped bordered hover>
            <tbody>
              <tr>
                <td>
                  <h4>Finalize</h4>
                  <Finalize
                    drizzle={this.props.drizzle}
                    drizzleState={this.props.drizzleState}>
                  
                  </Finalize>
                </td>
              </tr>
              <tr>
                <td>
                  <h4>Contribution statistics</h4>
                  <ContributionStatistics
                    drizzle={this.props.drizzle}
                    drizzleState={this.props.drizzleState}>

                  </ContributionStatistics>
                </td>
              </tr>
              <tr>
                <td>
                  <h4>Withdraw Funds</h4>
                  <WithdrawFunds
                    drizzle={this.props.drizzle}
                    drizzleState={this.props.drizzleState}>
                  
                  </WithdrawFunds>
                </td>
              </tr>
              <tr>
                <td>
                  <h4>Balance Of</h4>
                  <BalanceOfICO
                    drizzle={this.props.drizzle}
                    drizzleState={this.props.drizzleState}
                    methodName="balanceOf">
                    
                  </BalanceOfICO>
                </td>
              </tr>
              <tr>
                <td>
                  <h4>Contributions of</h4>
                  <BalanceOfICO
                    drizzle={this.props.drizzle}
                    drizzleState={this.props.drizzleState}
                    methodName="getContribution">
                  
                  </BalanceOfICO>
                </td>
              </tr>
              <tr>
                <td>
                  <h4>Deposits of</h4>
                  <BalanceOfICO
                    drizzle={this.props.drizzle}
                    drizzleState={this.props.drizzleState}
                    methodName="depositsOf">
                  
                  </BalanceOfICO>
                </td>
              </tr>
              <tr>
                <td>
                  <h4>Whitelist statistics</h4>
                  <WhitelistStatistics
                    drizzle={this.props.drizzle}
                    drizzleState={this.props.drizzleState}>

                  </WhitelistStatistics>
                </td>
              </tr>
              <tr>
                <td>
                  <h4>Move tokens from contract</h4>
                  <MoveTokensFromContract
                    drizzle={this.props.drizzle}
                    drizzleState={this.props.drizzleState}>

                  </MoveTokensFromContract>
                </td>
              </tr>
              <tr>
                <td>
                  <h4>Move BNB from contract</h4>
                  <MoveBNBFromContract
                    drizzle={this.props.drizzle}
                    drizzleState={this.props.drizzleState}>

                  </MoveBNBFromContract>
                </td>
              </tr>
              <tr>
                <td>
                  <h4>Change Admin</h4>
                  <ChangeAdmin
                    drizzle={this.props.drizzle}
                    drizzleState={this.props.drizzleState}>

                  </ChangeAdmin>
                </td>
              </tr>
              <tr>
                <td>
                  <h4>transferEscrowPrimary</h4>
                  implement using transferEscrowPrimary, probably not needed
                </td>
              </tr>
              <tr>
                <td>
                  <h4>Admin Issue Refund</h4>
                  <AdminIssueRefund
                    drizzle={this.props.drizzle}
                    drizzleState={this.props.drizzleState}
                    methodName="refund">
                    
                  </AdminIssueRefund>
                </td>
              </tr>
              <tr>
                <td>
                  <h4>Admin Issue withdraw</h4>
                  <AdminIssueRefund
                    drizzle={this.props.drizzle}
                    drizzleState={this.props.drizzleState}
                    methodName="withdrawTokens">
                    
                  </AdminIssueRefund>
                </td>
              </tr>
              <tr>
                <td>
                  <h4>Emergency Suicide</h4>
                  <EmergencySuicide
                    drizzle={this.props.drizzle}
                    drizzleState={this.props.drizzleState}>

                  </EmergencySuicide>
                </td>
              </tr>
              <tr>
                <td>
                  <h4>Pause ICO</h4>
                  <PauseICO
                    drizzle={this.props.drizzle}
                    drizzleState={this.props.drizzleState}>

                  </PauseICO>
                </td>
              </tr>
              <tr>
                <td>
                  <h4>Reset Escrow to Active</h4>
                  <ResetEscrow
                    drizzle={this.props.drizzle}
                    drizzleState={this.props.drizzleState}>

                  </ResetEscrow>
                </td>
              </tr>
              <tr>
                <td>
                  <h4>Set Escrow State</h4>
                  <SetEscrowState
                    drizzle={this.props.drizzle}
                    drizzleState={this.props.drizzleState}>

                  </SetEscrowState>
                </td>
              </tr>
              <tr>
                <td>
                  <h4>Set White List End Time</h4>
                  <SetTime
                    drizzle={this.props.drizzle}
                    drizzleState={this.props.drizzleState}
                    dateName="getTime"
                    setterName="setTime"
                    getterParameter={0}
                    setterParameter={0}>

                  </SetTime>
                </td>
              </tr>
              <tr>
                <td>
                  <h4>Set Open Time</h4>
                  <SetTime
                    drizzle={this.props.drizzle}
                    drizzleState={this.props.drizzleState}
                    dateName="getTime"
                    setterName="setTime"
                    getterParameter={1}
                    setterParameter={1}>

                  </SetTime>
                </td>
              </tr>
              <tr>
                <td>
                  <h4>Set non Whitelisted Start Time</h4>
                  <SetTime
                    drizzle={this.props.drizzle}
                    drizzleState={this.props.drizzleState}
                    dateName="getTime"
                    setterName="setTime"
                    getterParameter={2}
                    setterParameter={2}>

                  </SetTime>
                </td>
              </tr>
              <tr>
                <td>
                  <h4>Set Close Time</h4>
                  <SetTime
                    drizzle={this.props.drizzle}
                    drizzleState={this.props.drizzleState}
                    dateName="getTime"
                    setterName="setTime"
                    getterParameter={3}
                    setterParameter={3}>

                  </SetTime>
                </td>
              </tr>
              <tr>
                <td>
                  <h4>Set Vesting Release Time</h4>
                  <SetTime
                    drizzle={this.props.drizzle}
                    drizzleState={this.props.drizzleState}
                    dateName="getTime"
                    setterName="setTime"
                    getterParameter={4}
                    setterParameter={4}>

                  </SetTime>
                </td>
              </tr>
              <tr>
                <td>
                  <h4>Set Unpause Time</h4>
                  <SetTime
                    drizzle={this.props.drizzle}
                    drizzleState={this.props.drizzleState}
                    dateName="getTime"
                    setterName="setTime"
                    getterParameter={5}
                    setterParameter={5}>

                  </SetTime>
                </td>
              </tr>
              <tr>
                <td>
                  <h4>Set Begin Rate</h4>
                  <GetChangeValue
                    drizzle={this.props.drizzle}
                    drizzleState={this.props.drizzleState}
                    getterName="initialRate"
                    setterName="">

                  </GetChangeValue>
                </td>
              </tr>
              <tr>
                <td>
                  <h4>Set End Rate</h4>
                  <GetChangeValue
                    drizzle={this.props.drizzle}
                    drizzleState={this.props.drizzleState}
                    getterName="finalRate"
                    setterName="">

                  </GetChangeValue>
                </td>
              </tr>
              
              <tr>
                <td>
                  <h4>Set Softcap</h4>
                  <GetChangeValue
                    drizzle={this.props.drizzle}
                    drizzleState={this.props.drizzleState}
                    getterName="goal"
                    setterName="setCap"
                    setterParameter={0}
                    wei={true}>

                  </GetChangeValue>
                </td>
              </tr>
              <tr>
                <td>
                  <h4>Set Hardcap</h4>
                  <GetChangeValue
                    drizzle={this.props.drizzle}
                    drizzleState={this.props.drizzleState}
                    getterName="cap"
                    setterName="setCap"
                    setterParameter={1}
                    wei={true}>

                  </GetChangeValue>
                </td>
              </tr>
              <tr>
                <td>
                  <h4>Set individual Min Cap</h4>
                  <GetChangeValue
                    drizzle={this.props.drizzle}
                    drizzleState={this.props.drizzleState}
                    getterName="getIndividualMinCap"
                    setterName="setIndividualCap"
                    setterParameter={0}
                    wei={true}>

                  </GetChangeValue>
                </td>
              </tr>
              <tr>
                <td>
                  <h4>Set Whitelisted individual Max Cap Whitelisted</h4>
                  <GetChangeValue
                    drizzle={this.props.drizzle}
                    drizzleState={this.props.drizzleState}
                    getterName="getIndividualCap"
                    setterName="setIndividualCap"
                    getterParameter={1}
                    setterParameter={1}
                    wei={true}>

                  </GetChangeValue>
                </td>
              </tr>
              <tr>
                <td>
                  <h4>Set Whitelisted individual Max Cap Not Whitelisted</h4>
                  <GetChangeValue
                    drizzle={this.props.drizzle}
                    drizzleState={this.props.drizzleState}
                    getterName="getIndividualCap"
                    setterName="setIndividualCap"
                    getterParameter={2}
                    setterParameter={2}
                    wei={true}>
                    
                  </GetChangeValue>
                </td>
              </tr>
              <tr>
                <td>
                  <h4>Set token Allowance wallet address</h4>
                  <GetChangeValue
                    drizzle={this.props.drizzle}
                    drizzleState={this.props.drizzleState}
                    getterName="secondaryAddress"
                    setterName="setTokenAllowanceWallet"
                    getterParameter={3}>

                  </GetChangeValue>
                </td>
              </tr>
              <tr>
                <td>
                  <h4>Set beneficiary address</h4>
                  <GetChangeValue
                    drizzle={this.props.drizzle}
                    drizzleState={this.props.drizzleState}
                    getterName="secondaryAddress"
                    setterName="setBeneficiary"
                    getterParameter={2}>

                  </GetChangeValue>
                </td>
              </tr>
              <tr>
                <td>
                  <h4>Token Address</h4>
                  <GetChangeValue
                    drizzle={this.props.drizzle}
                    drizzleState={this.props.drizzleState}
                    getterName="token">

                  </GetChangeValue>
                </td>
              </tr>
              <tr>
                <td>
                  <h4>Escrow Address</h4>
                  <GetChangeValue
                    drizzle={this.props.drizzle}
                    drizzleState={this.props.drizzleState}
                    getterName="secondaryAddress"
                    getterParameter={0}>

                  </GetChangeValue>
                </td>
              </tr>
              <tr>
                <td>
                  <h4>Vault Address</h4>
                  <GetChangeValue
                    drizzle={this.props.drizzle}
                    drizzleState={this.props.drizzleState}
                    getterName="secondaryAddress"
                    getterParameter={1}>

                  </GetChangeValue>
                </td>
              </tr>
              <tr>
                <td>
                  <h4>Set non whitelist token percentage</h4>
                  <GetChangeValue
                    drizzle={this.props.drizzle}
                    drizzleState={this.props.drizzleState}
                    getterName="nonWhiteListPercentage"
                    setterName="setNonWhiteListPercentage">

                  </GetChangeValue>
                </td>
              </tr>
            </tbody>
          </Table>
            
        </div>
    );
  }
};

export default ICO;